import { useState, useEffect, useContext } from 'react';
import ListHeader from '../../SectionHeader';
import TablePagination from '../../TablePaginationComponent';
import BasicPopover from 'components/Popover';
import { ReactComponent as SortIcon } from '../../../assets/images/sort.svg';
import Filter from '../../Filter';
import useSort from '../../../hooks/useSort';
import Button from '../../Button';
import usePostData from '../../../hooks/usePostData';
import { findIndex } from 'lodash';
import closeIcon from '../../../assets/images/close.png';
import Api from 'utils/api';
import BasicDialog from 'components/Dialog';
import globalTranslating from '../../../translate.json';
import LabTranslate from '../translate.json';
import ExcelDownload from 'components/ExcelDownload';
import '../style.scss';
import Upload from 'components/Upload';
import GlobalContext from 'contexts';
import moment from 'moment';

const LabsList = () => {
  const translating = { ...globalTranslating, ...LabTranslate };
  const { currentUser } = useContext(GlobalContext);
  const [filteredLabs, setFilteredLabs] = useState([]);
  const [excelLabs, setExcelLabs] = useState([]);
  const { showFilters, toggle } = useSort();
  const [currentId, setCurrentId] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const { res: labsData, postData: getLabs } = usePostData();
  const { res: updateStatusRes, postData: updateLabStatus } = usePostData();
  const { res: updateRejectedSampleRes, postData: updateRejectedSample } =
    usePostData();
  const [showMessage, setShowMessage] = useState(false);
  const [mode, setMode] = useState();
  const [currentCLientProduct, setCurrentClientProduct] = useState();
  const [openModalChangeStatus, setOpenModalChangeStatus] = useState();
  const [disabaledBtn, setDisabledBtn] = useState(false);
  const [disabledSaveFile, setDisabledSaveFile] = useState(false);
  const handleUpdateStatus = (clientProductUuid) => {
    setCurrentClientProduct(clientProductUuid);
    updateLabStatus(
      `client-product/setNextStatus/${clientProductUuid}`,
      {},
      'patch'
    );
  };

  useEffect(() => {
    if (updateStatusRes?.affected === 1) {
      setShowMessage('נקלט בהצלחה');
      setTimeout(() => {
        setShowMessage(false);
        setAnchorEl(null);
        setMode(null);
        setDisabledBtn(false);
      }, 3000);
      let tmpLabs = [...filteredLabs];
      let index = findIndex(tmpLabs, {
        client_product_uuid: currentCLientProduct
      });
      if (index < 0) {
        index = findIndex(tmpLabs, { ClientProductId: currentCLientProduct });
      }
      tmpLabs[index].status = 'קליטה במעבדה';
      tmpLabs[index].LabDate = new Date();
      let tmpExcelLabs = JSON.parse(JSON.stringify(filteredLabs));
      tmpExcelLabs[index].LabDate = moment().format('DD.MM.YYYY');
      setExcelLabs(tmpExcelLabs);
      setFilteredLabs(tmpLabs);
    }
  }, [updateStatusRes]);

  const handleClick = (id, event) => {
    event.preventDefault();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    getLabs('client-product/Lab/details', {});
  }, []);

  useEffect(() => {
    if (labsData && labsData.length) {
      let tmpLabs = JSON.parse(JSON.stringify(labsData));
      tmpLabs.forEach((lab) => {
        if (lab.LabDate) lab.LabDate = moment(lab.LabDate).format('DD/MM/YYYY');
      });
      setExcelLabs(tmpLabs);
      setFilteredLabs(labsData);
    }
  }, [labsData]);

  useEffect(() => {
    if (filteredLabs && filteredLabs.length) {
      let tmpLabs = JSON.parse(JSON.stringify(filteredLabs));
      tmpLabs.forEach((lab) => {
        if (lab.LabDate) lab.LabDate = moment(lab.LabDate).format('DD/MM/YYYY');
      });
      setExcelLabs(tmpLabs);
    }
  }, [filteredLabs]);

  const actionsLabList = [];

  if (currentUser?.roleId === 1 || currentUser?.roleId === 5)
    actionsLabList.push({
      txt: 'תוצאות דוח גנטי',
      handleClick: (e) => {
        setMode({ name: 'upload', type: 'uploadGeneResultFile' });
        setAnchorEl(e.currentTarget);
      }
    });
  actionsLabList.push({
    icon: SortIcon,
    bottom: true,
    txt: 'עריכה',
    handleClickAction: () => {
      showFilters && setFilteredLabs(labsData);
      toggle(!showFilters);
    }
  });

  const tableHeaders = [
    translating.barcode,
    translating.firstName,
    translating.lastName,
    translating.tz,
    translating.productType,
    translating.testDate,
    translating.labDate,
    translating.status,
    ''
  ];

  const columns = [
    { value: 'barcode', bold: true },
    { value: 'first_name' },
    { value: 'last_name' },
    { value: 'tz' },
    { value: 'product_name' },
    { value: 'TestDate' },
    { value: 'LabDate', format: 'date' },
    { value: 'status' },
    { format: 'updateStatus', handleAction: (id) => handleUpdateStatus(id) }
  ];

  const sortFields = [
    {
      type: 'search',
      label: translating.search,
      placeholder: translating.type3Dots,
      name: 'search',
      fields: ['first_name', 'last_name', 'barcode']
    },
    {
      type: 'search',
      label: translating.searchBarcode,
      placeholder: translating.searchBarcode,
      name: 'searchBarcode',
      fields: ['barcode']
    },
    {
      type: 'date',
      subType: 'fromDate',
      label: translating.fromDate,
      name: 'fromDate',
      field: 'LabDate'
    },
    {
      type: 'date',
      subType: 'toDate',
      label: translating.toDate,
      name: 'toDate',
      field: 'LabDate'
    },
    {
      type: 'select',
      label: translating.status,
      name: 'status',
      options: [
        { id: 'שינוע למעבדה', name: 'שינוע למעבדה' },
        { id: 'קליטה במעבדה', name: 'קליטה במעבדה' }
      ],

      isId: true
    }
  ];

  const onFilter = (filteredData) => {
    setFilteredLabs(filteredData);
  };

  const onResetFilters = () => {
    setFilteredLabs(labsData);
  };

  const handleSaveFile = (file) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('fileName', file.name);
    setShowMessage('הקובץ בתהליך טעינה ,יקח כמה דקות');
    setDisabledSaveFile(true);

    Api.post(`/gene-analyze/${mode?.type}`, formData).then((res) => {
      if (res?.status == 201) {
        setTimeout(() => {
          setShowMessage(false);
          setAnchorEl(null);
        }, 3000);
        setShowMessage('הקובץ עלה בהצלחה');
        setDisabledSaveFile(false);
      }
    });
  };

  useEffect(() => {
    if (updateRejectedSampleRes) {
      window.location.reload();
    }
  }, [updateRejectedSampleRes]);

  const updateRejectedSampleFunc = () => {
    updateRejectedSample(
      `client-product/updateRejectedSample/${openModalChangeStatus}/79`,
      {},
      'post'
    );
  };

  const handleRejectSample = (id) => {
    setOpenModalChangeStatus(id);
  };

  return (
    <div className="labs-list">
      <ListHeader
        title={translating.labsListTitle}
        actions={actionsLabList}
      ></ListHeader>
      {filteredLabs?.length ? (
        <ExcelDownload
          data={excelLabs}
          filename={'lab_data.csv'}
        ></ExcelDownload>
      ) : null}
      {showFilters && (
        <Filter
          fields={sortFields}
          data={labsData}
          handleFilter={onFilter}
          handleReset={onResetFilters}
        ></Filter>
      )}
      <div className="terapists-list-wrapper-table">
        <TablePagination
          headers={tableHeaders}
          columns={columns}
          rows={filteredLabs}
          pagination={true}
          handleRowClick={(id, e, row) => {
            if (row?.product_type && row.product_type == 2) {
              if (row.status === 'שינוע למעבדה') {
                setMode({ name: 'barcode' });
                setCurrentId(row.client_product_uuid || row.ClientProductId);
                handleClick(id, e);
              } else if (row.status === 'קליטה במעבדה') {
                setMode({ name: 'rejected' });
                setCurrentId(row.client_product_uuid || row.ClientProductId);
                handleClick(id, e);
              }
            }
          }}
        ></TablePagination>
      </div>
      <BasicPopover anchorEl={anchorEl} handleClose={handleClose}>
        <div className="popover-container">
          <img
            className="close"
            src={closeIcon}
            alt={'close popover'}
            onClick={handleClose}
          />
          {mode?.name === 'barcode' ? (
            <div className="wrapper-items">
              <Button
                txt={'קליטה במעבדה'}
                handleClick={() => {
                  setDisabledBtn(true);
                  handleUpdateStatus(currentId);
                }}
                disable={disabaledBtn}
              ></Button>
            </div>
          ) : mode?.name === 'rejected' ? (
            <div className="wrapper-items">
              <Button
                txt={'פסילת דגימה'}
                handleClick={() => handleRejectSample(currentId)}
              ></Button>
            </div>
          ) : (
            mode?.name === 'upload' && (
              <Upload
                handleSaveFile={handleSaveFile}
                disabled={disabledSaveFile}
              ></Upload>
            )
          )}
          {showMessage && <div className="succsses-msg">{showMessage}</div>}
        </div>
      </BasicPopover>
      {openModalChangeStatus && (
        <BasicDialog
          title={'פסילת דגימה'}
          description={`האם אתה בטוח שאתה רוצה לפסול את הדגימה`}
          handleClose={() => {
            setOpenModalChangeStatus(null);
            handleClose();
          }}
          handleSubmit={updateRejectedSampleFunc}
        ></BasicDialog>
      )}
    </div>
  );
};

export default LabsList;
